
import { StockUpdate } from '../../types';
import { KEYS, get, set } from '../core';

// Fallback to localStorage when offline or during migration
export const getStockUpdates = (): StockUpdate[] => get<StockUpdate>(KEYS.STOCK_UPDATES);
export const setStockUpdates = (updates: StockUpdate[]): void => set(KEYS.STOCK_UPDATES, updates);
